import { Link } from 'react-router-dom';

const CharactersSection = () => {
  return (
    <div className='characters relative'>
      <div className='container mx-auto flex flex-col items-center'>
        <div className='char-list relative'>
          <div className='char-item'>
            <div className='char-item-image char-chua-cong'></div>
            <div className='char-item-title'>
              <div>Hóa Thân Hoàng Tộc</div>
              <div>Lựa Chọn Vận Mệnh</div>
            </div>
          </div>
          <div className='char-item'>
            <div className='char-item-image char-my-nhan'>
              <a className='view-more' href='/characters#my-nhan'></a>
            </div>
            <div className='char-item-title'>
              <div>Mỹ Nhân Tuyệt Hảo</div>
              <div>Chân Thực Từng Centimet</div>
            </div>
          </div>
          <div className='char-item'>
            <div className='char-item-image char-con-cai'></div>
            <div className='char-item-title'>
              <div>Sinh Con Đẻ Cái</div>
              <div>Nuôi Dưỡng Thành Tài</div>
            </div>
          </div>
          <div className='char-item'>
            <div className='char-item-image char-mon-khach'>
              <a className='view-more' href='/characters#mon-khach'></a>
            </div>
            <div className='char-item-title'>
              <div>Chiêu Mộ Nhân Tài</div>
              <div>Quy Phục Thiên Hạ</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CharactersSection;
